import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewLeave() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New leave request"
      listPath="/panel/leaves"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'employeeId', label: 'Employee', required: true },
            {
              key: 'leaveType',
              label: 'Leave type',
              type: 'select',
              required: true,
              options: [
                { value: 'casual', label: 'Casual leave' },
                { value: 'sick', label: 'Sick leave' },
                { value: 'earned', label: 'Earned leave' },
                { value: 'comp-off', label: 'Comp-off' },
                { value: 'unpaid', label: 'Unpaid' },
              ],
            },
            { key: 'fromDate', label: 'From date', type: 'date', required: true },
            { key: 'toDate', label: 'To date', type: 'date', required: true },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'days', label: 'Total days', type: 'number' },
            { key: 'reason', label: 'Reason', type: 'textarea' },
            {
              key: 'halfDay',
              label: 'Half day?',
              type: 'select',
              options: [
                { value: 'no', label: 'No' },
                { value: 'first', label: 'First half' },
                { value: 'second', label: 'Second half' },
              ],
            },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [{ key: 'medicalCertUrl', label: 'Medical certificate (sick leave)', placeholder: 'https://…' }],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
